<!-- <section id="content">

  <div class="page page-full page-calendar"> -->

    <div class="tbox tbox-sm">

      <!-- left side -->
      <div class="tcol w-lg bg-tr-white lt b-r">

        <!-- left side header-->
        <div class="p-15 bg-white">
          <!-- <button type="button" class="btn btn-greensea btn-xs mb-10 pull-right b-0" data-toggle="modal" (click)="addEditEvent(template)"
            href="#cal-new-event">
            <i class="fa fa-plus"></i>
          </button> -->
          <h4 class="custom-font text-default m-0">Events</h4>
        </div>
        <!-- /left side header -->

        <!-- left side body -->
        <div class="p-15 collapse collapse-xs collapse-sm" id="external-events">

          <div class="p-10 mb-10 event-control b-l b-2x b-greensea ui-draggable ui-draggable-handle" style="position: relative;" *ngFor="let event of events;let i = index;">
            <h3> {{ event?.title }} </h3>
            <p>
              {{ event?.start | date:'mediumDate' }} - {{ event?.end | date:'mediumDate' }} 
              <a class="pull-right text-muted event-remove" (click)="deleteEvent(event)" ><i class="fa fa-trash-o"></i></a>
            </p>
            
          </div>

        </div>
        <!-- /left side body -->

      </div>
      <!-- /left side -->


      <!-- right side -->
      <div class="tcol">

        <!-- right side header -->
        <div class="p-10 bg-white" style="background-color: #16a085 !important;">
          <!-- <div class="pull-right">
            <div class="btn-group">
              <div
                class="btn btn-primary"
                (click)="setView(CalendarView.Month)"
                [class.active]="view === CalendarView.Month"
              >
                Month
              </div>
              <div
                class="btn btn-primary"
                (click)="setView(CalendarView.Week)"
                [class.active]="view === CalendarView.Week"
              >
                Week
              </div>
              <div
                class="btn btn-primary"
                (click)="setView(CalendarView.Day)"
                [class.active]="view === CalendarView.Day"
              >
                Day
              </div>
            </div>
          </div>
          <h4 class="custom-font text-default m-0">Calendar</h4> -->
        
          <div class="col-md-4">
            <i 
            mwlCalendarPreviousView
            [view]="view"
            [(viewDate)]="viewDate"
            (viewDateChange)="closeOpenMonthViewDay()" class="fa fa-angle-left"></i>
            <div class="btn-group calendar-btn-group">
              <div
                class="calendar-btn"
                mwlCalendarPreviousView
                [view]="view"
                [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay()"
              >
                Previous
              </div>
              <div
                class="calendar-btn"
                mwlCalendarToday
                [(viewDate)]="viewDate"
              >
                Today
              </div>
              <div
                class="calendar-btn"
                mwlCalendarNextView
                [view]="view"
                [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay()"
              >
                Next
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <h3 class="cal-date" style="color: #ffff !important;">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
          </div>

          <div class="col-md-4">
            <i class="fa fa-angle-right" mwlCalendarNextView
            [view]="view"
            [(viewDate)]="viewDate"
            (viewDateChange)="closeOpenMonthViewDay()"></i>
            <div class="btn-group calendar-btn-group" style="float: right;">
              <div
                class="calendar-btn"
                (click)="setView(CalendarView.Month)"
                [class.active]="view === CalendarView.Month"
              >
                Month
              </div>
              <div
                class="calendar-btn"
                (click)="setView(CalendarView.Week)"
                [class.active]="view === CalendarView.Week"
              >
                Week
              </div>
              <div
                class="calendar-btn"
                (click)="setView(CalendarView.Day)"
                [class.active]="view === CalendarView.Day"
              >
                Day
              </div>
            </div>
          </div>    

        </div>
        <!-- /right side header -->

        <!-- right side body -->
        <div class="p-15">
          <div [ngSwitch]="view">
            <mwl-calendar-month-view
              *ngSwitchCase="CalendarView.Month"
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              [activeDayIsOpen]="activeDayIsOpen"
              (dayClicked)="dayClicked($event.day)"
              (eventClicked)="handleEvent('Clicked', $event.event)"
              (eventTimesChanged)="eventTimesChanged($event)"
            >
            </mwl-calendar-month-view>
            <mwl-calendar-week-view
              *ngSwitchCase="CalendarView.Week"
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              (eventClicked)="handleEvent('Clicked', $event.event)"
              (eventTimesChanged)="eventTimesChanged($event)"
            >
            </mwl-calendar-week-view>
            <mwl-calendar-day-view
              *ngSwitchCase="CalendarView.Day"
              [viewDate]="viewDate"
              [events]="events"
              [refresh]="refresh"
              (eventClicked)="handleEvent('Clicked', $event.event)"
              (eventTimesChanged)="eventTimesChanged($event)"
            >
            </mwl-calendar-day-view>
          </div>

        </div>
        <!-- /right side body -->


      </div>
      <!-- /right side -->



    </div>

  <!-- </div>
</section> -->

<ng-template #template>
  <form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Add Event</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <div class="row">

        <!-- Event -->
        <div class="form-group col-sm-12">
          <label for="first-name">{{lang?.event}}</label>
          <input type="text" class="form-control" formControlName="event"
            [ngClass]="formErrorClass(createForm.controls.event, createFormSubmitted)">
          <span class="text-danger"
            *ngIf="(createForm.controls.event?.touched || createFormSubmitted) && createForm.controls.event?.errors?.required">
            This field is required.
          </span>
        </div>

        <!-- Start Date -->
        <div class="form-group col-sm-12">
          <label for="first-name">{{lang?.start_date}}</label>
          <input type="date" class="form-control" formControlName="start_date"
            [ngClass]="formErrorClass(createForm.controls.start_date, createFormSubmitted)">
          <span class="text-danger"
            *ngIf="(createForm.controls.start_date?.touched || createFormSubmitted) && createForm.controls.start_date?.errors?.required">
            This field is required.
          </span>
        </div>

        <!-- End Date -->
        <div class="form-group col-sm-12">
          <label for="first-name">{{lang?.end_date}}</label>
          <input type="date" class="form-control" formControlName="end_date"
            [ngClass]="formErrorClass(createForm.controls.end_date, createFormSubmitted)">
          <span class="text-danger"
            *ngIf="(createForm.controls.end_date?.touched || createFormSubmitted) && createForm.controls.end_date?.errors?.required">
            This field is required.
          </span>
        </div>

      </div>

    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-success">{{ lang?.save }}</button>
      <button type="button" class="btn btn-warning" (click)="modalRef.hide()">{{ lang?.close }}</button>
    </div>
  </form>
</ng-template>
